import { canUseDOM } from 'exenv';
import ponyfill from 'fetch-ponyfill';
import bluebird from 'bluebird';
import { createFetch, originalFetch } from '@is24at/react-utils';
import { APP_CONTEXT_REQUEST_OPTS, SERVER_URI } from 'core/configs';

const universalFetch = createFetch(canUseDOM ? '' : SERVER_URI, {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError: () => {},
  baseOpts: APP_CONTEXT_REQUEST_OPTS,
});

export { universalFetch };
export { originalFetch };

const OriginalFetchExports = ponyfill({
  Promise: bluebird,
});
export { OriginalFetchExports };
